import { Injectable, signal } from '@angular/core';
import type { NotificationConfig, NotificationButton, NotificationType } from './notification.types';

@Injectable({ providedIn: 'root' })
export class NotificationService {
  private readonly _isVisible = signal(false);
  private readonly _message = signal<string>('');
  private readonly _type = signal<NotificationType>('info');
  private readonly _buttons = signal<NotificationButton[]>([]);
  private autoCloseTimer: ReturnType<typeof setTimeout> | null = null;

  readonly isVisible = this._isVisible.asReadonly();
  readonly message = this._message.asReadonly();
  readonly type = this._type.asReadonly();
  readonly buttons = this._buttons.asReadonly();

  show(config: NotificationConfig): void {
    this.clear();
    this._message.set(config.message);
    this._type.set(config.type);
    this._buttons.set(config.buttons || []);
    this._isVisible.set(true);

    if (config.autoClose && config.autoCloseMs) {
      this.autoCloseTimer = setTimeout(() => {
        this.hide();
      }, config.autoCloseMs);
    }
  }

  hide(): void {
    this.clear();
  }

  private clear(): void {
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
    this._isVisible.set(false);
    this._message.set('');
    this._buttons.set([]);
  }
}
